import React from 'react';
import IDraftData from '../../types/DraftData';
import DraftGroup from './DraftGroup';

interface DraftTableProps {
  data: IDraftData[];
  onEditDraft;
  onRemoveDraft;
}

/**
 * Draft table component with high cohesion
 * Handles table structure and accessibility features
 */
const DraftTable: React.FC<DraftTableProps> = ({ 
  data,
  onEditDraft,
  onRemoveDraft
}) => {
  const chunkArrayByValue = (arr, conditionFn): IDraftData[][] => {
    arr.sort((a, b) => a.id - b.id); // Ensure array is sorted by id

    return arr.reduce((acc, currentItem) => {
      const lastChunk = acc[acc.length - 1];

      // If it's the first item or the condition is met for a new chunk
      if (!lastChunk || conditionFn(currentItem, lastChunk[0])) {
        acc.push([currentItem]); // Start a new chunk
      } else {
        lastChunk.push(currentItem); // Add to the current chunk
      }
      return acc;
    }, []);
  }

  // Chunk by 'id' property
  const drafts = chunkArrayByValue(data, (item, firstInChunk) => item.id !== firstInChunk.id);

  return (
    <div className="draft-table__wrapper">
      <table 
        className="draft-table"
        aria-label="Flight Range Draft"
        aria-rowcount={data.length + 1} // +1 for header
      >
        <tbody>
          {drafts.map((draft, index) => (
            <DraftGroup
              key={`${draft[0].id}-${draft[0].modifiedDate}`} 
              draft={draft}
              aria-rowindex={index + 2} // +2 because header is row 1
              onEditDraft={onEditDraft}
              onRemoveDraft={onRemoveDraft}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DraftTable;